import { render, staticRenderFns } from "./DisplayMedia.vue?vue&type=template&id=1dcc5158&"
import script from "./DisplayMedia.vue?vue&type=script&lang=js&"
export * from "./DisplayMedia.vue?vue&type=script&lang=js&"
import style0 from "./DisplayMedia.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports